import backend from "../api";
import { toast } from "react-toastify";
import {
  AUTH_SIGNUP_REQUEST,
  AUTH_SIGNUP_SUCCESS,
  AUTH_SIGNUP_FAIL,
  AUTH_SIGNUP_RESET,
  AUTH_SIGNIN_REQUEST,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNIN_FAIL,
} from "../constants/authPaymentConstants";

export const signup = (userData) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_SIGNUP_REQUEST });

    const { data } = await backend.post("/auth/signup", userData);

    dispatch({ type: AUTH_SIGNUP_SUCCESS, payload: data });

    // Success toast
    toast.success(data.message);
    return { success: true };
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: AUTH_SIGNUP_FAIL,
      payload: errorMessage,
    });

    // Error toast
    toast.error(errorMessage);
    return { success: false, message: errorMessage };
  }
};

export const signin = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_SIGNIN_REQUEST });

    const { data } = await backend.post("/auth/signin", { email, password });

    // Store user info in localStorage
    localStorage.setItem("userInfo", JSON.stringify(data));
    sessionStorage.setItem("token", data.token);

    dispatch({ type: AUTH_SIGNIN_SUCCESS, payload: data });

    // Success toast
    toast.success(data.message);

    return { success: true };
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: AUTH_SIGNIN_FAIL,
      payload: errorMessage,
    });

    // Error toast
    toast.error(errorMessage);
    return { success: false, message: errorMessage };
  }
};

// Optional: Action to reset signup state
export const resetSignup = () => (dispatch) => {
  dispatch({ type: AUTH_SIGNUP_RESET });
};
